export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Software Development", path: "/software-development" },
  { label: "Student Empowerment", path: "/student-empowerment" },
  { label: "Career Path", path: "/career-path" },
  { label: "About Us", path: "/about" },
  { label: "Contact Us", path: "/contact" },
];

export const HERO_DATA = {
  tagline: "Innovation Ecosystem",
  title: "Building Tomorrow's Technology, Today",
  subtitle: "An ecosystem combining software development, startup incubation, placement training, and mentorship.",
  cta_primary: "Explore Our Services",
  cta_secondary: "Get In Touch",
};

export const WHAT_WE_DO = [
  {
    icon: "Code",
    title: "Software Development",
    description: "End-to-end custom software solutions for enterprises and startups.",
  },
  {
    icon: "GraduationCap",
    title: "Student Empowerment",
    description: "Comprehensive programs for entrepreneurs and job-seekers with roadmaps & mentorship.",
  },
  {
    icon: "Trophy",
    title: "Events & Hackathons",
    description: "Industry-level hackathons, workshops, and expos that bring together innovators.",
  },
  {
    icon: "Users",
    title: "Mentorship & Branding",
    description: "Access to industry experts, personal branding programs, and startup branding support.",
  },
];

export const CORE_DIVISIONS = [
  {
    title: "Custom Software Solutions",
    description: "From web and mobile applications to complex enterprise systems, we deliver scalable software tailored to your business needs.",
    icon: "Monitor",
  },
  {
    title: "Entrepreneur Track",
    description: "A 10-stage startup roadmap covering idea validation, MVP development, business structuring, and funding assistance.",
    icon: "Rocket",
  },
  {
    title: "Placement Track",
    description: "Structured training program with technical skills, soft skills, internship support, and guaranteed placement assistance.",
    icon: "Briefcase",
  },
  {
    title: "Hackathons & Events",
    description: "Organize and participate in cutting-edge hackathons, workshops, and technology expos with industry collaboration.",
    icon: "Zap",
  },
  {
    title: "Mentorship Network",
    description: "Connect with seasoned industry experts who provide guidance on technology, business strategy, and career growth.",
    icon: "Network",
  },
  {
    title: "Startup Branding",
    description: "Complete branding support including identity design, digital presence, and go-to-market strategy for emerging startups.",
    icon: "Palette",
  },
];

export const IMPACT_METRICS = [
  { value: 50, suffix: "+", label: "Projects Delivered" },
  { value: 100, suffix: "+", label: "Students Empowered" },
  { value: 10, suffix: "+", label: "Hackathons Organized" },
  { value: 20, suffix: "+", label: "Industry Mentors" },
  { value: 15, suffix: "+", label: "Corporate Partners" },
];

export const TESTIMONIALS = [
  {
    name: "Arjun Mehta",
    role: "CTO, TechVista Solutions",
    category: "client",
    program: "Custom Software Development",
    outcome: "Uproot Innovation transformed our legacy system into a modern cloud-native platform. Our operational efficiency improved by 40% within the first quarter.",
    avatar: 0,
  },
  {
    name: "Priya Sharma",
    role: "Founder, EduLeap",
    category: "student",
    program: "Entrepreneur Track - Stage 8",
    outcome: "The 10-stage startup roadmap gave me the clarity I needed. From idea validation to securing seed funding of 15L, Uproot guided me every step.",
    avatar: 1,
  },
  {
    name: "Rahul Deshmukh",
    role: "Software Engineer, Infosys",
    category: "student",
    program: "Placement Track",
    outcome: "The technical training and mock interviews prepared me thoroughly. I received 3 offers and chose my dream company, all thanks to Uproot's placement program.",
    avatar: 2,
  },
  {
    name: "Sneha Kulkarni",
    role: "Product Manager, FinServ Corp",
    category: "client",
    program: "Enterprise Solutions",
    outcome: "Their team delivered a fintech platform that handles 10,000+ daily transactions flawlessly. The development process was transparent and efficient.",
    avatar: 3,
  },
  {
    name: "Vikram Joshi",
    role: "Student, VIT Pune",
    category: "hackathon",
    program: "InnoHack 2025",
    outcome: "Winning the hackathon was just the beginning. The mentorship and networking opportunities that followed opened doors I never imagined possible.",
    avatar: 0,
  },
  {
    name: "Ananya Reddy",
    role: "Co-founder, GreenTech AI",
    category: "student",
    program: "Entrepreneur Track - Stage 10",
    outcome: "Uproot's incubation support helped us go from a college project to a funded startup with 12 employees in just 18 months.",
    avatar: 1,
  },
];

export const SOFTWARE_DEV_DATA = {
  hero: {
    tagline: "Software Development",
    title: "Crafting Digital Solutions That Drive Growth",
    subtitle: "From startups to enterprises, we build custom software that transforms ideas into powerful, scalable products.",
  },
  customSolutions: [
    { title: "Web Applications", description: "Modern, responsive web apps built with cutting-edge frameworks for optimal performance and user experience.", icon: "Globe" },
    { title: "Mobile Applications", description: "Native and cross-platform mobile apps for iOS and Android that deliver seamless experiences.", icon: "Smartphone" },
    { title: "Cloud Solutions", description: "Scalable cloud-native applications with microservices architecture and containerized deployments.", icon: "Cloud" },
    { title: "API Development", description: "Robust RESTful and GraphQL APIs that power seamless integrations across platforms.", icon: "Workflow" },
  ],
  domains: [
    { name: "FinTech", icon: "Landmark" },
    { name: "HealthTech", icon: "Heart" },
    { name: "EdTech", icon: "BookOpen" },
    { name: "E-Commerce", icon: "ShoppingCart" },
    { name: "Logistics", icon: "Truck" },
    { name: "Real Estate", icon: "Building" },
  ],
  process: [
    { step: "01", title: "Discovery", description: "We understand your business goals, target audience, and technical requirements through comprehensive workshops." },
    { step: "02", title: "Planning", description: "Detailed project roadmap, architecture design, and technology stack selection tailored to your needs." },
    { step: "03", title: "Design", description: "UI/UX design with interactive prototypes, ensuring intuitive user journeys and visual consistency." },
    { step: "04", title: "Development", description: "Agile development sprints with regular demos, code reviews, meetings and continuous integration." },
    { step: "05", title: "Testing", description: "Comprehensive QA including unit tests, integration tests, performance testing, and security audits." },
    { step: "06", title: "Deployment", description: "Smooth launch with CI/CD pipelines, monitoring setup, and post-launch optimization support." },
  ],
};

export const ENTREPRENEUR_TRACK = [
  { stage: 1, title: "Idea Generation", description: "Brainstorm and refine your startup idea using proven innovation frameworks and market analysis tools." },
  { stage: 2, title: "Market Research", description: "Deep-dive into market size, competition analysis, and target audience identification." },
  { stage: 3, title: "Idea Validation", description: "Test your concept with real users through surveys, interviews, and rapid prototyping." },
  { stage: 4, title: "Business Model Canvas", description: "Structure your business model covering value proposition, revenue streams, and cost structure." },
  { stage: 5, title: "MVP Development", description: "Build a minimum viable product with core features to test market fit and gather user feedback." },
  { stage: 6, title: "User Testing & Iteration", description: "Refine your product based on real user feedback, analytics, and A/B testing results." },
  { stage: 7, title: "Business Structuring", description: "Legal entity formation, compliance setup, and operational framework establishment." },
  { stage: 8, title: "Go-to-Market Strategy", description: "Launch planning including marketing strategy, pricing model, and distribution channels." },
  { stage: 9, title: "Funding Assistance", description: "Pitch deck preparation, investor networking, and guidance through seed funding rounds." },
  { stage: 10, title: "Scale & Growth", description: "Growth hacking strategies, team building, and expansion planning for sustainable scaling." },
];

export const PLACEMENT_TRACK = [
  { stage: 1, title: "Skill Assessment", description: "Comprehensive evaluation of current technical and soft skills to create a personalized learning path." },
  { stage: 2, title: "Foundation Building", description: "Core programming concepts, data structures, and algorithms training with hands-on exercises." },
  { stage: 3, title: "Technology Specialization", description: "Deep training in chosen technology stack — full-stack, data science, cloud, or mobile development." },
  { stage: 4, title: "Project Development", description: "Build real-world projects that demonstrate your skills and create a strong portfolio." },
  { stage: 5, title: "Soft Skills Training", description: "Communication, teamwork, leadership, and presentation skills essential for corporate environments." },
  { stage: 6, title: "HR & Interview Prep", description: "Resume building, LinkedIn optimization, and comprehensive HR interview preparation." },
  { stage: 7, title: "Technical Mock Interviews", description: "Rigorous mock interviews with industry professionals covering coding, system design, and problem-solving." },
  { stage: 8, title: "Internship Placement", description: "Facilitated internship opportunities with partner companies for real-world experience." },
  { stage: 9, title: "Performance Review", description: "Feedback sessions, skill gap analysis, and targeted improvement before final placement drives." },
  { stage: 10, title: "Placement Assistance", description: "Direct placement support with 25+ corporate partners, interview scheduling, and offer negotiation guidance." },
];

export const EVENTS_DATA = {
  hackathons: [
    { name: "InnoHack 2025", participants: "500+", theme: "AI for Social Good", status: "Completed" },
    { name: "CodeStorm", participants: "300+", theme: "FinTech Innovation", status: "Upcoming" },
    { name: "DevSprint", participants: "400+", theme: "Sustainable Tech", status: "Completed" },
  ],
  workshops: [
    "Cloud Architecture Masterclass",
    "AI/ML for Beginners",
    "Startup Pitch Perfect",
    "Full Stack Development Bootcamp",
    "Cybersecurity Essentials",
    "Design Thinking Workshop",
  ],
  colleges: [
    "VIT Pune",
    "MIT WPU",
    "COEP Technological University",
    "Symbiosis Institute of Technology",
    "Savitribai Phule Pune University",
    "PICT Pune",
  ],
};

export const MENTORSHIP_DATA = {
  mentors: [
    { name: "Dr. Rajesh Kumar", role: "AI Research Lead, Google", specialization: "Artificial Intelligence & Machine Learning" },
    { name: "Meera Patel", role: "VP Engineering, Flipkart", specialization: "Scalable Systems & Architecture" },
    { name: "Suresh Iyer", role: "Startup Advisor, YCombinator", specialization: "Startup Strategy & Fundraising" },
    { name: "Kavita Nair", role: "Design Director, Adobe", specialization: "Product Design & UX Strategy" },
  ],
  programs: [
    { title: "Personal Branding", description: "Build your professional identity through LinkedIn optimization, thought leadership content, and public speaking." },
    { title: "Startup Branding", description: "Complete brand identity including logo design, brand guidelines, digital presence, and marketing collateral." },
    { title: "Corporate Partnerships", description: "We bridge the gap between academic talent and industry needs through corporate collaboration programs." },
  ],
};

export const ABOUT_DATA = {
  vision: "To be the leading innovation ecosystem that bridges the gap between education, entrepreneurship, and industry, empowering the next generation of tech leaders.",
  mission: "We drive innovation by combining advanced software development with student empowerment programs, creating an ecosystem where ideas turn into impact.",
  journey: [
    { year: "2024", title: "Founded", description: "Uproot Innovation was established with a vision to democratize tech education and software development." },
    { year: "2025", title: "First Hackathon", description: "Organized our first major hackathon with 200+ participants from across 15 colleges." },
    { year: "2026", title: "Entrepreneur Track Launch", description: "Launched the 10-stage Entrepreneur Track, supporting 50+ startup ideas in the first year." },
  ],
  values: [
    { title: "Innovation First", description: "We push boundaries and embrace new technologies to deliver quality solutions.", icon: "Lightbulb" },
    { title: "Impact Driven", description: "Every project and program is designed to create measurable, lasting impact.", icon: "Target" },
    { title: "Collaboration", description: "We believe the best outcomes emerge from diverse teams working together.", icon: "Handshake" },
    { title: "Integrity", description: "Transparency and ethical practices are at the core of everything we do.", icon: "Shield" },
    { title: "Continuous Learning", description: "We foster a culture of curiosity and growth, both internally and in our community.", icon: "BookOpen" },
    { title: "Excellence", description: "We set high standards and deliver quality that exceeds expectations.", icon: "Award" },
  ],
};

export const CONTACT_DATA = {
  office: {
    address: "chennai, Tamil Nadu, India",
    email: "Uprootinnovation@gmail.com \n Info@uprootinnovation.com",
    phone: "+91 82205 45028",
    hours: "Mon-Sat: 8am - 8pm IST",
  },
  social: [
    { platform: "LinkedIn", href: "https://www.linkedin.com/company/uproot-innovation/" },
    { platform: "Instagram", href: "https://www.instagram.com/uprootinnovation" },
  ],
};

export const HOME_PAGE_DATA = {
  hero: {
    titlePrefix: "Building Tomorrow's",
    titleHighlight: "Technology",
    titleSuffix: ", Today",
  },
  sections: {
    whatWeDo: {
      label: "What We Do",
      title: "A Complete Innovation Ecosystem",
      description:
        "We don't just build software — we build futures. Our ecosystem spans across technology, education, and entrepreneurship.",
    },
    coreDivisions: {
      label: "Core Divisions",
      title: "Six Pillars of Innovation",
    },
    impact: {
      label: "Impact",
      title: "Numbers That Speak",
    },
    testimonials: {
      label: "Testimonials",
      title: "What Our Community Says",
      loading: "Loading testimonials…",
      empty: "No testimonials yet.",
      avatarAlt: "Testimonial",
      avatarSrc: "user.png",
      backgroundImage: "url(community.png)",
    },
    cta: {
      title: "Ready to Innovate?",
      description:
        "Whether you're a startup looking for development support, a student seeking career guidance, or a company needing tech solutions — we're here for you.",
      primaryButton: "Book a Consultation",
      secondaryButton: "Learn More About Us",
    },
  },
};

export const SOFTWARE_DEV_PAGE_DATA = {
  sections: {
    customSolutions: {
      label: "Custom Solutions",
      title: "Tailored Software for Every Need",
      description:
        "We build custom solutions that scale with your business, using modern technologies and best practices.",
    },
    process: {
      label: "Our Process",
      title: "How We Build",
      backgroundImage: "url(dev_bg.png)",
    },
    domains: {
      label: "Industry Expertise",
      title: "Domain-Based Development",
    },
    feedback: {
      label: "Client Feedbacks",
      formTitle: "Share Your Experience",
      fields: {
        fullName: "Full Name",
        fullNamePlaceholder: "Jane Smith",
        role: "Role / Company",
        rolePlaceholder: "CEO at Acme Corp",
        serviceUsed: "Service Used",
        serviceUsedPlaceholder: "Web Development, Mobile App, etc.",
        outcome: "Outcome / Result",
        outcomePlaceholder: "Share the results and impact Uproot Innovation delivered...",
      },
      submitButton: "Submit Feedback",
      testimonialsTitle: "What Clients Say",
      loading: "Loading testimonials…",
      empty: "No client testimonials yet.",
      avatarAlt: "Testimonial",
      avatarSrc: "user.png",
      backgroundImage: "url(testimonial.png)",
    },
    cta: {
      title: "Have a Project in Mind?",
      description: "Let's discuss your requirements and build something extraordinary together.",
      button: "Request a Proposal",
    },
  },
};

export const STUDENT_PAGE_DATA = {
  hero: {
    tagline: "Student Empowerment",
    titlePrefix: "Your Journey to",
    titleHighlight: "Success",
    titleSuffix: "Starts Here",
    subtitle:
      "Whether you dream of building a startup or landing your dream job, our structured tracks and mentorship programs will guide you every step of the way.",
  },
  programsIntro: {
    title: "Explore Our Programs",
    subtitle: "Click on a track below to learn more",
  },
  tabs: {
    entrepreneur: {
      label: "Entrepreneur Track",
      title: "Entrepreneur Track",
      description: "A structured 10-stage roadmap to transform your idea into a funded, scalable startup.",
    },
    placement: {
      label: "Placement Track",
      title: "Placement Track",
      description:
        "A comprehensive 10-stage program designed to make you industry-ready with 95% placement success rate.",
    },
    events: {
      label: "Events & Hackathons",
      title: "Events & Hackathons",
      description: "Industry-level events that bring together innovators, mentors, and opportunities.",
      hackathonsTitle: "Hackathons",
      hackathonsDescription:
        "Our hackathons are intensive, time-bound innovation sprints designed to push students beyond the classroom. Participants form cross-functional teams to ideate, prototype, and pitch real-world solutions—all within 24–48 hours.",
      hackathonHighlights: [
        {
          icon: "Zap",
          title: "Industry-Themed Challenges",
          description:
            "Each hackathon centres around industry problems. AI for social good, FinTech innovation, sustainable tech. so students build solutions with real impact.",
        },
        {
          icon: "Award",
          title: "Expert Judging & Prizes",
          description:
            "Projects are evaluated by industry experts and top teams receive cash prizes, incubation support, and introductions to investors and hiring managers.",
        },
        {
          icon: "Users",
          title: "Networking & Mentorship",
          description:
            "Beyond the code, hackathons serve as networking hubs where students connect with peers, mentors, and company representatives for future opportunities.",
        },
      ],
      workshopsTitle: "Workshops",
      collegeTitle: "College Collaborations",
      collegeDescription:
        "We partner with leading colleges and universities to bring industry-relevant learning directly into academic ecosystems. Our collaboration model is built around three pillars:",
      collegePillars: [
        {
          icon: "BookOpen",
          title: "Campus Workshops",
          description:
            "We conduct hands-on workshops on campus covering full-stack development, AI/ML, cloud architecture, etc. bridging the gap between theory and practice.",
        },
        {
          icon: "Briefcase",
          title: "Internship Pipelines",
          description:
            "Our college partners get priority access to internship and project opportunities with our client network, giving students real work experience before graduation.",
        },
        {
          icon: "Award",
          title: "Co-Hosted Hackathons",
          description:
            "We co-organise hackathons on campus, providing themes, mentors, judging panels, and prizes—creating an innovation culture right within the college community.",
        },
      ],
    },
    mentorship: {
      label: "Mentorship & Branding",
      title: "Mentorship & Branding",
      description: "Connect with industry leaders and build a brand that stands out.",
      howWeMentorTitle: "How We Mentor",
      howWeMentor: [
        {
          icon: "Users",
          title: "1-on-1 Guidance",
          description:
            "Every student is paired with an industry mentor for personalised advice on career goals, skill development, and project feedback through regular one-on-one sessions.",
        },
        {
          icon: "Target",
          title: "Goal-Oriented Roadmaps",
          description:
            "Mentors help students create structured action plans with milestones. whether the goal is landing a job, launching a startup, or mastering a new technology stack. We are here!",
        },
        {
          icon: "MessageSquare",
          title: "Live Review Sessions",
          description:
            "Regular group review sessions where mentors provide real-time feedback on resumes, portfolios, pitch decks, and code, helping students refine their work to a professional standard.",
        },
      ],
      brandingTitle: "Branding Programs",
    },
  },
  testimonials: {
    sectionLabel: "Student Feedbacks",
    formTitle: "Share Your Experience",
    fields: {
      fullName: "Full Name",
      fullNamePlaceholder: "John Doe",
      schoolCollege: "School / College",
      schoolCollegePlaceholder: " XYZ college of Engineering, etc.",
      programUsed: "Program or Service Used",
      programUsedPlaceholder: "Entrepreneur Track, Placement Track, etc.",
      outcome: "Outcome / Result",
      outcomePlaceholder: "Share your experience and results...",
    },
    submitButton: "Submit Testimonial",
    storiesTitle: "Community Stories",
    loading: "Loading testimonials…",
    empty: "No community stories yet.",
    avatarAlt: "Testimonial",
    avatarSrc: "user.png",
    backgroundImage: "url(testimonial.png)",
  },
};

export const ABOUT_PAGE_DATA = {
  hero: {
    tagline: "About Us",
    titlePrefix: "Empowering Innovation,",
    titleHighlight: "One Step",
    titleSuffix: "at a Time",
    subtitle:
      "We are an innovation ecosystem that bridges the gap between education, entrepreneurship, and industry.",
  },
  differentiators: {
    label: "Why Uproot Innovation",
    title: "What Sets Us Apart",
    description:
      "We don't just build software or run programs — we create an ecosystem where technology, talent, and ambition converge.",
    backgroundImage: "url(wallpaper.png)",
    cards: [
      {
        icon: "Target",
        title: "End-to-End Support",
        description:
          "From ideation to deployment, from student onboarding to job placement — we walk with you through every stage of the journey.",
      },
      {
        icon: "Handshake",
        title: "Industry-Academia Bridge",
        description:
          "We connect students directly with real-world projects, mentors, and companies — ensuring the skills they learn translate to careers.",
      },
      {
        icon: "Lightbulb",
        title: "Innovation-First Culture",
        description:
          "Whether it's a hackathon, a client project, or an internal initiative, we approach every challenge with creativity and a bias for action.",
      },
      {
        icon: "BookOpen",
        title: "Structured Learning Tracks",
        description:
          "Our 10-stage Entrepreneur and Placement tracks give students a clear, actionable roadmap instead of overwhelming them with information.",
      },
      {
        icon: "Shield",
        title: "Transparent & Ethical",
        description:
          "No hidden fees, no false promises. We operate with full transparency in our pricing, processes, and expectations for clients and students alike.",
      },
      {
        icon: "Award",
        title: "Proven Impact",
        description:
          "With successful hackathons, placed students, delivered client projects, and real testimonials from students & clients, our results speak louder than words.",
      },
    ],
  },
  values: {
    label: "Core Values",
    title: "What We Stand For",
  },
  cta: {
    title: "Want to Be Part of Our Story?",
    description: "Join us as a student, partner, or client and let's build something remarkable together.",
    button: "Get In Touch",
  },
};

export const CONTACT_PAGE_DATA = {
  socialIconMap: {
    GitHub: "Github",
    Instagram: "Instagram",
    LinkedIn: "Linkedin",
    Linkdin: "Linkedin",
  },
  subjectLabels: {
    software: "Software Development",
    entrepreneur: "Entrepreneur Track",
    placement: "Placement Track",
    hackathon: "Events & Hackathons",
    mentorship: "Mentorship & Branding",
    partnership: "Corporate Partnership",
    other: "Other",
  },
  subjectOptions: [
    { value: "software", label: "Software Development" },
    { value: "entrepreneur", label: "Entrepreneur Track" },
    { value: "placement", label: "Placement Track" },
    { value: "hackathon", label: "Events & Hackathons" },
    { value: "mentorship", label: "Mentorship & Branding" },
    { value: "partnership", label: "Corporate Partnership" },
    { value: "other", label: "Other" },
  ],
  hero: {
    tagline: "Contact Us",
    titlePrefix: "Let's Start a",
    titleHighlight: "Conversation",
    subtitle:
      "Have a project in mind, want to join our programs, or just want to say hello? We'd love to hear from you.",
  },
  inquiry: {
    title: "Send Us a Message",
    subtitle: "Fill out the form below and our team will get back to you within 24 hours.",
    fields: {
      fullName: "Full Name",
      fullNamePlaceholder: "John Doe",
      email: "Email",
      emailPlaceholder: "john@example.com",
      phone: "Phone",
      phonePlaceholder: "+91 98765 43210",
      subject: "Subject",
      subjectPlaceholder: "Select a subject",
      message: "Message",
      messagePlaceholder: "Tell us about your requirements...",
    },
    submitButton: "Send Message",
  },
  office: {
    title: "Office Details",
    labels: {
      address: "Address",
      email: "Email",
      phone: "Phone",
      workingHours: "Working Hours",
    },
    followUs: "Follow Us",
  },
};

export const PRIVACY_POLICY_DATA = {
  lastUpdated: "February 22, 2026",
  hero: {
    tagline: "Privacy Policy",
    titlePrefix: "Your Privacy,",
    titleHighlight: "Handled Responsibly",
    subtitle:
      "This Privacy Policy explains how Uproot Innovation collects, uses, shares, and protects personal information when you visit our website or interact with our services.",
  },
};

export const TERMS_OF_SERVICE_DATA = {
  lastUpdated: "February 22, 2026",
  hero: {
    tagline: "Terms of Service",
    titlePrefix: "Clear Terms for",
    titleHighlight: "Using Our Website",
    subtitle:
      "These Terms of Service govern your access to and use of the Uproot Innovation website and related services.",
  },
};
